import React from 'react';
import links from 'utils/links';
// import { Link } from 'react-router-dom';

/** redux **/
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as selectors from './redux/reducer';

import Loader from '../../components/Loader';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import CardContent from '@material-ui/core/CardContent';

import FormControl from '@material-ui/core/FormControl';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import ShortExperiences from './ActivitiesSource';
import EventCardSlider from '../../components/card/EventTypeSlider';
import { storeCityName } from 'utils/';
// import { format } from 'date-fns';

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  media: {
    height: 400,
  },
  about_body: {
    margin: theme.spacing.unit,
    marginTop: theme.spacing.unit + 7,
  },
  sec_para: {
    marginTop: theme.spacing.unit,
  },
  readmore: {
    marginTop: theme.spacing.unit,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  paramode: {
    marginTop: theme.spacing.unit + 7,
  },
  inputContainer: {
    backgroundColor: '#eab209',
  },
  select: {
    borderRadius: '5px',
    backgroundColor: theme.palette.others.bg1,
  },
  margin: {
    width: '100%',
  },
  form_margin: {
    marginTop: theme.spacing.unit + 2,
    marginBottom: theme.spacing.unit + 2,
  },
  event_card: {
    padding: '10px',
    backgroundColor: 'white',
  },
  sub_label: {
    marginTop: theme.spacing.unit * 2 + 4,
    marginBottom: theme.spacing.unit * 2 + 4,
  },
  ahara_container: {
    padding: '10px',
    backgroundColor: theme.palette.others.bg1,
  },
  liveExperiencelink: {
    textDecoration: 'underline',
    color: '#c44a33',
  },
});

class CulinaryExp extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      activitiesStep: ShortExperiences,
    };
  }
  componentWillMount(){
    storeCityName(this.props.match.params.cityname);
  }
  componentDidMount() {
    this.props.dispatch(actions.getData(this.props.match.params.cityname));
  }
  handleChange = event => {
    this.props.history.push('/experiences/' + event.target.value);
    this.props.dispatch(actions.getData(event.target.value));
  };
  render() {
    const {
      classes,
      loading,
      history,
      cities,
      // mostExplored,
      // localExperiences,
      // topRead,
      topExperiences,
    } = this.props;
    const cityname = this.props.match.params.cityname;

    const filteredEventData = topExperiences.filter(function(data) {
      return data.eventType === 'EVENT';
    });

    const FilteredExperienceData = topExperiences.filter(function(exp) {
      return exp.eventType === 'EXPERIENCE';
    });
    // console.log( data.days >= format(new Date(), 'DD-MM-YYYY'));

    if (loading) {
      return <Loader />;
    } else {
      // let currentCityName = '';
      // for (var i = 0; i < cities.length; i++) {
      //   if (cities[i].cityID === cityname) {
      //     currentCityName = cities[i].cityName;
      //   }
      // }

      return (
        <div className={classes.root}>
          <Grid container>
            <Grid item xs={12}>
              <CardMedia
                className={classes.media}
                image="/img/g1.png"
                title="about us"
              />
            </Grid>
            <Grid item className={classes.about_body} xs={12}>
              <Typography component="h3" variant="h5">
                Ahara
              </Typography>
              <Typography
                className={classes.paramode}
                component="h6"
                variant="body1"
              >
                Deeply immersive culinary experiences hosted by experts such as
                chefs, restauranteurs, cuisine veterans and more. Crafted along
                with our hand-picked partners, each Ahara experience is designed
                to be a delightfully informative window into cuisine and
                culture.
              </Typography>
              {/* <Typography
                className={classes.sec_para}
                component="h6"
                variant="body1"
              >
                What’s common to these delightful food experiences is thateach
                of them was discovered because of a local foodie’s
                recommendation or guidance. What’s also common to each of them
                is that they were the inspiration behind Talking Street.
              </Typography> */}
            </Grid>

            {/* <Grid item xs={12}>
              <CardMedia
                className={classes.media}
                image="/img/g2.png"
                title="about us"
              />
            </Grid> */}
            <Grid item className={classes.about_body} xs={12}>
              <Typography component="h3" variant="h5">
                Why Ahara?
              </Typography>
              <Typography
                className={classes.paramode}
                component="h6"
                variant="body1"
              >
                Ahara is sanskrit for 'a satisfying meal'.
              </Typography>
              <Typography
                className={classes.paramode}
                component="h6"
                variant="body1"
              >
                We believe that food is among the foremost ways to experience a
                city's culture. And so, each Ahara experience is hand-crafted
                with and hosted by experts - gifted chefs, passionate
                restauranteurs, tea sommeliers, coffee roasters, wine experts -
                to bring out the subtle nuances of ingredients, dishes, cuisines
                and culture. They are designed to take you deep into a cuisine,
                help you learn a new culinary art, sample a unique cuisine, try
                your hand at cooking up a meal or even just entice you to sit
                back and enjoy a meal listenting to a professional story-teller.
              </Typography>

              <Typography
                className={classes.paramode}
                component="h6"
                variant="body1"
              >
                Our endeavour is that each Ahara experience should leave you
                sated and inspired, in body, mind and soul.
              </Typography>
              <Typography component="h6" variant="body1">
                <div className={classes.readmore}>
                  <a href="https://www.talkingstreet.in/experiences">
                    EXPLORE EXPERIENCES
                  </a>
                  <a href="https://www.talkingstreet.in/experiences">
                    <img src={'/icons/right-arrow.png'} alt="our story" />
                  </a>
                </div>
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <CardMedia
                className={classes.media}
                image="/img/g3.png"
                title="about us"
              />
            </Grid>
            <Grid item className={classes.about_body} xs={12}>
              <Typography component="h3" variant="h5">
                Ahara Experiences
              </Typography>
              <Typography
                className={classes.paramode}
                component="h6"
                variant="body1"
              >
                Here are the various types of Ahara experiences you can explore
                and enjoy.
              </Typography>{' '}
              <br />
              <Typography
                varient="body1"
                component="h6"
                style={{ fontSize: '1.089375rem' }}
              >
                Short experiences (3-5 hours)
              </Typography>
              <ul>
                <Typography variant="body1" component="h6">
                  {this.state.activitiesStep.shrtExperience.map((step, id) => {
                    return <li key={id}>{step.experience}</li>;
                  })}
                </Typography>
              </ul>
              <Typography
                varient="body1"
                component="h6"
                style={{ fontSize: '1.089375rem' }}
              >
                Long duration (1-3 days)
              </Typography>
              <ul>
                <Typography variant="body1" component="h6">
                  {this.state.activitiesStep.longDurationExperience.map(
                    (step, id) => {
                      return <li key={id}>{step.lgExp}</li>;
                    }
                  )}
                </Typography>
              </ul>
              <Typography component="h6" variant="body1">
                <div className={classes.readmore}>
                  <a href="https://www.talkingstreet.in/experiences">
                    EXPLORE EXPERIENCES
                  </a>
                  <a href="https://www.talkingstreet.in/experiences">
                    <img src={'/icons/right-arrow.png'} alt="our team" />
                  </a>
                </div>
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <CardMedia
                className={classes.media}
                image="/img/g4.png"
                title="about us"
              />
            </Grid>
            <Grid item className={classes.ahara_container} xs={12}>
              <Typography component="h3" variant="h5">
                Our Ahara partners
              </Typography>
              <Typography
                className={classes.paramode}
                component="h6"
                variant="body1"
              >
                Ahara experiences are designed in conjunction with culinary
                experts who bring deep passion and knowledge to the table
                (literally!). Their in-depth understanding of ingredients,
                dishes, cuisines and cultures enables us to craft unique
                sessions that are delightful, informative and fun. They are
                also, usually, great conversationalists who love sharing their
                expertise and insights. To sum it up, Ahara experiences are
                crafted and delivered with love and a desire to share and
                inspire.
              </Typography>
              <Typography component="h6" variant="body1">
                <div className={classes.readmore}>
                  <a href="https://www.talkingstreet.in/experiences">
                    EXPLORE EXPERIENCES
                  </a>
                  <a href="https://www.talkingstreet.in/experiences">
                    <img
                      src={'/icons/right-arrow.png'}
                      alt="Talkingstreet community"
                    />
                  </a>
                </div>
              </Typography>
            </Grid>
          </Grid>
          <div className={classes.inputContainer}>
            <CardContent>
              <Typography
                className={classes.form_margin}
                component="h6"
                variant="subtitle1"
              >
                {/* EXPLORE IN YOUR CITY */}
                We are live in following citites:
              </Typography>
              <a
                href={links.ourLiveExperienceCities('bengaluru')}
                className={classes.liveExperiencelink}
              >
                Bangalore
              </a>
              {'  '}
              <a
                href={links.ourLiveExperienceCities('varanasi')}
                className={classes.liveExperiencelink}
              >
                Varanasi
              </a>
              {'  '}
              <a
                href={links.ourLiveExperienceCities('mumbai')}
                className={classes.liveExperiencelink}
              >
                Mumbai
              </a>{' '}
              <a
                href={links.ourLiveExperienceCities('delhi')}
                className={classes.liveExperiencelink}
              >
                Delhi
              </a>
              <br />
              <br />
              <FormControl className={classes.margin}>
                <Select
                  className={classes.select}
                  value={cityname}
                  onChange={this.handleChange}
                  input={
                    <OutlinedInput
                      labelWidth={0}
                      name="city"
                      id="outlined-city-simple"
                    />
                  }
                >
                  {cities.map((city, id) => (
                    <MenuItem key={city.id + 1} value={city.name}>
                      {city.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </CardContent>
          </div>

          {/* -----  Temporary commented ------- */}
          {/* <div className={classes.event_card}>
            <Typography variant="subtitle1" className={classes.sub_label}>
              MOST EXPLORED TRAILS
            </Typography>
            <CardsSlider history={history} cards={mostExplored} />
          </div> */}
          <div className={classes.ahara_container}>
            {FilteredExperienceData.length > 0 ? (
              <Typography variant="subtitle1" className={classes.sub_label}>
                AHARA EXPERIENCES AROUND {cityname.toUpperCase()}
              </Typography>
            ) : (
              ''
            )}
            <EventCardSlider history={history} cards={FilteredExperienceData} />
          </div>
          <div className={classes.event_card}>
            {filteredEventData.length > 0 ? (
              <Typography variant="subtitle1" className={classes.sub_label}>
                EVENTS
              </Typography>
            ) : (
              ''
            )}
            <EventCardSlider history={history} cards={filteredEventData} />
          </div>
          {/* <div className={classes.event_card}>
            <Typography variant="subtitle1" className={classes.sub_label}>
              EVENTS TO FULFILL YOUR CURIOSITY
            </Typography>
            <CardsSlider history={history} cards={topExperiences} />
          </div> */}
          {/* -----  Temporary commented end here------- */}
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return selectors.getAllValues(state);
}

export default connect(mapStateToProps)(withStyles(styles)(CulinaryExp));
